export const getLineCd = (selectedPolicy, policies) => {
    return policies.find(policy => policy.policyRef === selectedPolicy.value)?.lineCd || {}
}